// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-title{font-weight:700}.outer-container{border:1px solid #e9e9e9;border-radius:16px;cursor:pointer;margin:20px 0;padding:24px}.radio-container{align-items:center;display:flex}.selected{border-color:#4f44e0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
